import * as i0 from '@angular/core';
import { Injectable, Component, ViewChild, Input, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, ReactiveFormsModule } from '@angular/forms';
import * as errorUtils from 'error-message-utility';
import * as i3 from 'ngx-toastr';
import * as i4 from 'primeng/api';
import * as i5 from 'reference-library';
import * as i6 from '@angular/common';
import * as i7 from 'primeng/table';
import * as i8 from 'primeng/confirmdialog';
import * as i9 from 'primeng/inputtext';
import * as i10 from 'primeng/tooltip';
import * as i11 from 'primeng/inputswitch';
import { InputSwitchModule } from 'primeng/inputswitch';
import * as i12 from 'primeng/button';
import * as i13 from 'primeng/paginator';
import { PrimengLibraryModule } from 'primeng-library';

// import { ImagilityBaseResponse } from '../../../../src/app/data/models/response.model';
// import { ImagilityBaseResponse } from 'projects/app-models/src/interface/response.model';  data/models/response.model
class ExternalLinksService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getExternalLinkList(getApiFlag, payload) {
        return this.httpClient.post(`/externalLink/${getApiFlag}`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    createExternalLinks(payload) {
        return this.httpClient.post(`/externalLink`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    updateExternalLinks(payload, id) {
        return this.httpClient.put(`/externalLink/${id}`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    deleteExternalLinks(id, linkName) {
        var lnkNme = this.toEncrypt(linkName);
        return this.httpClient.delete(`/externalLink/${id}/${lnkNme}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
ExternalLinksService.ɵfac = function ExternalLinksService_Factory(t) { return new (t || ExternalLinksService)(i0.ɵɵinject(i1.HttpClient)); };
ExternalLinksService.ɵprov = i0.ɵɵdefineInjectable({ token: ExternalLinksService, factory: ExternalLinksService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExternalLinksService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["p"];
function ExternalLinksComponent_div_6_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.getGlobalErrorMessages("REQUIRED"), " ");
} }
function ExternalLinksComponent_div_6_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.getGlobalErrorMessages("REQUIRED"), " ");
} }
function ExternalLinksComponent_div_6_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1, " Please provide a valid Link url. ");
    i0.ɵɵelementEnd();
} }
const _c1 = function (a0) { return { error: a0 }; };
function ExternalLinksComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "form", 15);
    i0.ɵɵlistener("ngSubmit", function ExternalLinksComponent_div_6_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.onSubmit(ctx_r8.externalLinksForm); });
    i0.ɵɵelementStart(2, "div", 16);
    i0.ɵɵelementStart(3, "div", 17);
    i0.ɵɵelementStart(4, "p", 18);
    i0.ɵɵtext(5, " Link Name ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 19);
    i0.ɵɵtemplate(7, ExternalLinksComponent_div_6_div_7_Template, 2, 1, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 21);
    i0.ɵɵelementStart(9, "p", 22);
    i0.ɵɵtext(10, "URL");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "input", 23);
    i0.ɵɵtemplate(12, ExternalLinksComponent_div_6_div_12_Template, 2, 1, "div", 20);
    i0.ɵɵtemplate(13, ExternalLinksComponent_div_6_div_13_Template, 2, 0, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 24);
    i0.ɵɵelementStart(15, "p", 25);
    i0.ɵɵtext(16);
    i0.ɵɵelement(17, "i", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "p-inputSwitch", 27);
    i0.ɵɵlistener("onChange", function ExternalLinksComponent_div_6_Template_p_inputSwitch_onChange_18_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.handleChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 28);
    i0.ɵɵelementStart(20, "div", 29);
    i0.ɵɵelementStart(21, "button", 30);
    i0.ɵɵelementStart(22, "span", 4);
    i0.ɵɵtext(23, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "button", 31);
    i0.ɵɵlistener("click", function ExternalLinksComponent_div_6_Template_button_click_24_listener() { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.onCancel(); });
    i0.ɵɵelementStart(25, "span", 4);
    i0.ɵɵtext(26, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r0.externalLinksForm);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1, ctx_r0.submitted && ctx_r0.myForm.bookMark.errors));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c1, ctx_r0.submitted && ctx_r0.myForm.bookMark.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.externalLinksForm.get("bookMark").invalid && (ctx_r0.externalLinksForm.get("bookMark").dirty || ctx_r0.externalLinksForm.get("bookMark").touched));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("pattern", ctx_r0.urlRegExp);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.externalLinksForm.get("url").invalid && (ctx_r0.externalLinksForm.get("url").dirty || ctx_r0.externalLinksForm.get("url").touched) && (ctx_r0.externalLinksForm.controls["url"].errors == null ? null : ctx_r0.externalLinksForm.controls["url"].errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.externalLinksForm.get("url").invalid && (ctx_r0.externalLinksForm.get("url").dirty || ctx_r0.externalLinksForm.get("url").touched) && (ctx_r0.externalLinksForm.controls["url"].errors == null ? null : ctx_r0.externalLinksForm.controls["url"].errors.pattern));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.switchName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("pTooltip", "Slide this to ON position, to make Link visible for ", ctx_r0.toolTipMessage, ". Slide to OFF position to hide Link visible for ", ctx_r0.toolTipMessage, ".");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r0.externalLinksForm.invalid);
} }
function ExternalLinksComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 33);
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3, "Link Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th", 4);
    i0.ɵɵtext(5, "URL");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 4);
    i0.ɵɵtext(7, "Access");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 4);
    i0.ɵɵtext(9, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", "30%");
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("width", "45%");
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("width", "10%");
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("width", "15%");
} }
function ExternalLinksComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵelementStart(4, "a", 34);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td");
    i0.ɵɵelementStart(7, "div", 35);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵelementStart(10, "div", 36);
    i0.ɵɵelementStart(11, "div", 37);
    i0.ɵɵelementStart(12, "button", 38);
    i0.ɵɵlistener("click", function ExternalLinksComponent_ng_template_11_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r18); const row_r13 = ctx.$implicit; const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.onDelete(row_r13); });
    i0.ɵɵelementStart(13, "span", 4);
    i0.ɵɵtext(14, "Delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div");
    i0.ɵɵelementStart(16, "button", 39);
    i0.ɵɵlistener("click", function ExternalLinksComponent_ng_template_11_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r18); const row_r13 = ctx.$implicit; const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.onEdit(row_r13); });
    i0.ɵɵelementStart(17, "span", 4);
    i0.ɵɵtext(18, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r13 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(row_r13.linkName);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", row_r13.linkUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(row_r13.linkUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", row_r13.isLinkPublic ? "Public" : "Private", " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r2.userId != row_r13.createdBy);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r2.userId != row_r13.createdBy);
} }
function ExternalLinksComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 40);
    i0.ɵɵtext(2, "No Links Available.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ExternalLinksComponent_p_paginator_13_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-paginator", 41, 42);
    i0.ɵɵlistener("onPageChange", function ExternalLinksComponent_p_paginator_13_Template_p_paginator_onPageChange_0_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.paginationEvent($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("rows", ctx_r4.pageSize)("totalRecords", ctx_r4.paginationRecordCount)("rowsPerPageOptions", ctx_r4.pageSizeOptions);
} }
const _c2 = function (a0, a1) { return { "mt-3": a0, "p-4": a1 }; };
const _c3 = function (a0, a1, a2, a3) { return { "btn-fromTask": a0, "btn-fromBenProfile": a1, "edit-create-active pr-2 pl-2": a2, " pr-1 pl-1": a3 }; };
class ExternalLinksComponent {
    constructor(fb, externallinkservice, toastr, renderer, confirmationService, referenceLibraryService) {
        this.fb = fb;
        this.externallinkservice = externallinkservice;
        this.toastr = toastr;
        this.renderer = renderer;
        this.confirmationService = confirmationService;
        this.referenceLibraryService = referenceLibraryService;
        this.inputData = {};
        this.bookMarks = [];
        this.isCreateEdit = false;
        this.switchName = "Public Access?";
        this.disabledControls = false;
        this.pageIndex = 1; // default
        this.pageSize = 10;
        this.switchStatus = true;
        this.pageSizeOptions = [10, 15, 25, 50];
        this.isEditParam = false;
        this.submitted = false;
        this.toolTipMessage = "";
        this.urlRegExp = new RegExp('^(https?://)(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$', 'i');
        this.paginationRecordCount = 0;
        this.userType = sessionStorage.getItem("userTypeRole");
        this.userId = sessionStorage.getItem("userId");
    }
    ngOnInit() {
        // console.log(this.inputData, "external-links-subtask-details");
        if (this.inputData && this.inputData.fromBenProfile) {
            this.listBeneficiaryId = this.inputData.externalBeneficiaryId;
            this.taskIdDetails = null;
            var bene = this.toEncrypt('beneficiary');
            this.getAPIFlag = `${this.listBeneficiaryId}/${bene}`;
        }
        if (this.inputData && this.inputData.fromTask) {
            this.taskIdDetails = sessionStorage.getItem("taskID");
            // console.log(this.taskIdDetails, "string-number");
            this.listBeneficiaryId = null;
            if (this.inputData.subTaskType) {
                var tsk = this.toEncrypt('task');
                this.getAPIFlag = `${this.inputData.subTaskType}/${tsk}`;
            }
            else {
                var sprTsk = this.toEncrypt('superTask');
                this.getAPIFlag = `${this.taskIdDetails}/${sprTsk}`;
            }
        }
        this.externalLinksForm = this.fb.group({
            bookMark: ["", Validators.required],
            url: [
                "",
                [
                    Validators.required
                ],
            ],
            private: [false],
            create: [""],
        });
        this.getExternalLinkList();
    }
    get myForm() {
        return this.externalLinksForm.controls;
    }
    getExternalLinkList() {
        this.bookMarks = [];
        let req = {
            pageNumber: this.pageIndex,
            pageSize: this.pageSize,
            userType: this.userType,
        };
        /* let urlEndPoint = ''
          if (this.inputData.subTaskType) {
            urlEndPoint = '/externalLink'
          } */
        this.externallinkservice
            .getExternalLinkList(this.getAPIFlag, req)
            .subscribe((data) => {
            if (data.externalLinks && data.externalLinks.elements.length) {
                this.paginationRecordCount = data.externalLinks.totalCount;
                this.bookMarks = data.externalLinks.elements.map((item, index) => {
                    item["isLinkPublic"] =
                        item.isPublicAttorney === 1 &&
                            item.isPublicBeneficiary === 1 &&
                            item.isPublicPetitioner === 1;
                    return item;
                });
            }
        });
    }
    paginationEvent(event) {
        let payload = {
            pageNumber: event.page + 1,
            pageSize: event.rows,
            userType: this.userType,
        };
        this.externallinkservice
            .getExternalLinkList(this.getAPIFlag, payload)
            .subscribe((data) => {
            if (data.externalLinks && data.externalLinks.elements.length) {
                this.paginationRecordCount = data.externalLinks.totalCount;
                this.bookMarks = data.externalLinks.elements.map((item, index) => {
                    item["isLinkPublic"] =
                        item.isPublicAttorney === 1 &&
                            item.isPublicBeneficiary === 1 &&
                            item.isPublicPetitioner === 1;
                    return item;
                });
            }
        });
    }
    handleChange(param) {
        this.switchStatus = param.checked;
    }
    onCreate() {
        if (this.isCreateEdit) {
            this.isCreateEdit = false;
        }
        this.isCreateEdit = true;
        setTimeout(() => {
            this.renderer.selectRootElement("#linkName").focus();
        });
        if (this.userType === "Petitioner") {
            this.toolTipMessage = "Lawfirm and Beneficiary";
        }
        else if (this.userType === "Attorney") {
            this.toolTipMessage = "Petitioner and Beneficiary";
        }
        else {
            this.toolTipMessage = "Petitioner and Lawfirm";
        }
    }
    onSubmit(form) {
        this.submitted = true;
        if (form.valid) {
            if (!this.externalLinksForm.value.private) {
                if (this.userType === "Petitioner") {
                    this.isPublicPetitioner = 1;
                    this.isPublicAttorney = 0;
                    this.isPublicBeneficiary = 0;
                }
                else if (this.userType === "Attorney") {
                    this.isPublicPetitioner = 0;
                    this.isPublicAttorney = 1;
                    this.isPublicBeneficiary = 0;
                }
                else if (this.userType === "Beneficiary") {
                    this.isPublicPetitioner = 0;
                    this.isPublicAttorney = 0;
                    this.isPublicBeneficiary = 1;
                }
            }
            else {
                this.isPublicPetitioner = 1;
                this.isPublicAttorney = 1;
                this.isPublicBeneficiary = 1;
            }
            let req = {
                beneficiaryId: this.listBeneficiaryId,
                createdBy: this.userId,
                isPublicAttorney: this.isPublicAttorney,
                isPublicBeneficiary: this.isPublicBeneficiary,
                isPublicPetitioner: this.isPublicPetitioner,
                linkName: this.externalLinksForm.value.bookMark,
                linkUrl: this.externalLinksForm.value.url,
                superTaskId: this.taskIdDetails,
                taskId: this.inputData.subTaskType,
            };
            if (!this.updateId) {
                this.externallinkservice.createExternalLinks(req).subscribe((res) => {
                    if (res.status == 200) {
                        this.toastr.success(res.message, 'Success');
                        this.getExternalLinkList();
                        this.paginator.changePage(0);
                    }
                });
            }
            else {
                this.externallinkservice
                    .updateExternalLinks(req, this.updateId)
                    .subscribe((res) => {
                    if (res.status == 200) {
                        this.toastr.success(res.message, 'Success');
                        this.getExternalLinkList();
                        this.paginator.changePage(0);
                    }
                });
            }
            this.externalLinksForm.reset();
            this.updateId = "";
            this.isCreateEdit = false;
        }
        else {
            alert("Please fill all the required fields to create a super hero!");
            return false;
        }
    }
    onCancel() {
        this.externalLinksForm.reset();
        this.isCreateEdit = false;
    }
    onEdit(params) {
        this.isEditParam = true;
        this.updateId = params.id;
        let isSwitch;
        if (params.isPublicBeneficiary === 1) {
            isSwitch = true;
        }
        else {
            isSwitch = false;
        }
        this.isCreateEdit = true;
        this.externalLinksForm.controls["bookMark"].setValue(params.linkName);
        this.externalLinksForm.controls["url"].setValue(params.linkUrl);
        this.externalLinksForm.controls["private"].setValue(params.isLinkPublic);
        setTimeout(() => {
            this.renderer.selectRootElement("#linkName").focus();
        });
    }
    onDelete(row) {
        this.confirmationService.confirm({
            message: `Are you sure you want to delete link url ${row.linkName}?`,
            key: "deleteexternallink",
            accept: () => {
                this.externallinkservice
                    .deleteExternalLinks(row.id, row.linkName)
                    .subscribe((res) => {
                    if (res.status == 200) {
                        this.toastr.success(res.message, 'Success');
                        this.getExternalLinkList();
                        this.paginator.changePage(0);
                    }
                });
            },
            reject: () => { },
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
    ngAfterViewInit() {
        this.translet();
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
}
ExternalLinksComponent.ɵfac = function ExternalLinksComponent_Factory(t) { return new (t || ExternalLinksComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(ExternalLinksService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i4.ConfirmationService), i0.ɵɵdirectiveInject(i5.ReferenceLibraryService)); };
ExternalLinksComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ExternalLinksComponent, selectors: [["lib-external-links"]], viewQuery: function ExternalLinksComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
    } }, inputs: { inputData: "inputData" }, decls: 15, vars: 13, consts: [[1, "row", "tab-container", "external-links-container", 3, "ngClass"], [1, "col-3", "tab-label", "tab-height", "btn-confirm"], [1, "lbl-text"], ["icon", "pi pi-plus", 1, "btn-create", 3, "ngClass", "click"], [1, "common-bene-class-for-translation"], ["class", "create-container div_confirm", 4, "ngIf"], [1, "pt-3"], [1, "mat-elevation-z8"], ["styleClass", "p-datatable-striped", "dataKey", "id", "emptyMessage", "No Links Available", 1, "pa-table", "im-card-no-border-table", "im-card-table-noborder-spacing", "table", "column-wrap", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], ["length", "paginationRecordCount", 3, "rows", "totalRecords", "rowsPerPageOptions", "onPageChange", 4, "ngIf"], ["header", "Delete", "key", "deleteexternallink"], [1, "create-container", "div_confirm"], [3, "formGroup", "ngSubmit"], [1, "row"], [1, "col-4"], [1, "label-cls", "required", "mb-2", "mt-3", "common-bene-class-for-translation", 3, "ngClass"], ["id", "linkName", "type", "text", "formControlName", "bookMark", "placeholder", "Enter Link Name", "value", "", "pInputText", "", 1, "btn-bookmark", 3, "ngClass"], ["class", "invalid-message common-bene-class-for-translation", 4, "ngIf"], [1, "col-5"], [1, "label-cls", "required", "mb-2", "mt-3", "common-bene-class-for-translation"], ["type", "text", "formControlName", "url", "placeholder", "https://drive.google.com/drive/my-drive/fileOrFolderName", "value", "", "pInputText", "", 1, "btn-bookmark", 3, "pattern"], [1, "col-2"], [1, "label-cls", "mb-2", "mt-3", "common-bene-class-for-translation"], [1, "pi", "pi-info-circle", "tool-tipClr", 3, "pTooltip"], ["formControlName", "private", 3, "onChange"], [1, "row", "mt-3", "mb-3"], [1, "col", "pt-1"], ["type", "submit", "pButton", "", 3, "disabled"], ["pButton", "", 1, "ml-2", "btn-cancel", 3, "click"], [1, "invalid-message", "common-bene-class-for-translation"], [1, "text-uppercase", "table-header"], ["target", "_blank", 3, "href"], [1, "summery-txt", "pl-0"], [1, "col-md-2", "pr-0", "pl-0"], [1, "table-delete"], ["type", "button", "pButton", "", "pTooltip", "Delete", "icon", "pi pi-trash", 1, "p-button-rounded", "p-button-text", "pull-right", 3, "disabled", "click"], ["type", "button", "pButton", "", "pTooltip", "Edit", "icon", "pi pi-pencil", 1, "p-button-rounded", "p-button-text", "pull-right", 3, "disabled", "click"], ["colspan", "6", 1, "text-center", "common-bene-class-for-translation"], ["length", "paginationRecordCount", 3, "rows", "totalRecords", "rowsPerPageOptions", "onPageChange"], ["p", ""]], template: function ExternalLinksComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "button", 3);
        i0.ɵɵlistener("click", function ExternalLinksComponent_Template_button_click_3_listener() { return ctx.onCreate(); });
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵtext(5, "Create New External Link");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, ExternalLinksComponent_div_6_Template, 27, 15, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "p-table", 8);
        i0.ɵɵtemplate(10, ExternalLinksComponent_ng_template_10_Template, 10, 8, "ng-template", 9);
        i0.ɵɵtemplate(11, ExternalLinksComponent_ng_template_11_Template, 19, 6, "ng-template", 10);
        i0.ɵɵtemplate(12, ExternalLinksComponent_ng_template_12_Template, 3, 0, "ng-template", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, ExternalLinksComponent_p_paginator_13_Template, 2, 3, "p-paginator", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "p-confirmDialog", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c2, !ctx.inputData.fromTask, ctx.inputData && ctx.inputData.fromBenProfile));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(8, _c3, ctx.inputData.fromTask, !ctx.inputData.fromTask, ctx.isCreateEdit, !ctx.isCreateEdit));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isCreateEdit);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("value", ctx.bookMarks);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.paginationRecordCount > 0);
    } }, directives: [i6.NgClass, i6.NgIf, i7.Table, i4.PrimeTemplate, i8.ConfirmDialog, i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlName, i9.InputText, i1$1.PatternValidator, i10.Tooltip, i11.InputSwitch, i12.ButtonDirective, i13.Paginator], styles: [".p-datatable-thead[_ngcontent-%COMP%]{height:50px!important}a[_ngcontent-%COMP%]{cursor:pointer}.align-tabs[_ngcontent-%COMP%]{padding:10px}.btn-fromTask[_ngcontent-%COMP%]{color:#3686b1!important;background-color:#fff!important;border-radius:0!important}.btn-fromTask.edit-create-active[_ngcontent-%COMP%]{border:1px solid #3686b1!important;border-bottom:none!important}.btn-fromBenProfile[_ngcontent-%COMP%]{color:#3686b1!important;background-color:#fff!important;border-radius:0!important}.btn-fromBenProfile.edit-create-active[_ngcontent-%COMP%]{border:1px solid #3686b1!important;border-bottom:none!important}.lbl-text[_ngcontent-%COMP%]{text-align:center;font:normal normal 600 22px/14px Source Sans Pro;letter-spacing:0;opacity:1}.activeTimeLine[_ngcontent-%COMP%]{color:#01a0da}.btn-delete[_ngcontent-%COMP%]{padding:0!important}.edit-delete-align[_ngcontent-%COMP%]{display:flex}.create-container[_ngcontent-%COMP%]{width:100%;border:1px solid #3686b1!important;background-color:#f5f7f7}.btn-confirm[_ngcontent-%COMP%]{padding-bottom:0!important;padding-left:0;background-color:#fff!important}.btn-confirm[_ngcontent-%COMP%]   .lbl-text[_ngcontent-%COMP%]{text-align:start}.btn-confirm[_ngcontent-%COMP%]   .btn-create[_ngcontent-%COMP%]{border:none;border-bottom:1px solid #3686b1}.div_confirm[_ngcontent-%COMP%]{width:100%;background-color:#f5f7f7}.btn-bookmark[_ngcontent-%COMP%], .div_confirm[_ngcontent-%COMP%]{border:1px solid #3686b1!important}.btn-cancel[_ngcontent-%COMP%]{background-color:#fff;font-size:1rem!important}.btn-cancel[_ngcontent-%COMP%], .tool-tipClr[_ngcontent-%COMP%]{color:#01a0da}.column-wrap[_ngcontent-%COMP%]{word-break:normal;overflow-wrap:anywhere}.table-header[_ngcontent-%COMP%]{height:3rem}.table-delete[_ngcontent-%COMP%]{margin-left:4.75rem}.delete-msg[_ngcontent-%COMP%]{color:red}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExternalLinksComponent, [{
        type: Component,
        args: [{
                selector: "lib-external-links",
                templateUrl: "external-links.component.html",
                styleUrls: ["external-links.component.scss"],
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: ExternalLinksService }, { type: i3.ToastrService }, { type: i0.Renderer2 }, { type: i4.ConfirmationService }, { type: i5.ReferenceLibraryService }]; }, { paginator: [{
            type: ViewChild,
            args: ["p", { static: false }]
        }], inputData: [{
            type: Input
        }] }); })();

class ExternalLinksModule {
}
ExternalLinksModule.ɵfac = function ExternalLinksModule_Factory(t) { return new (t || ExternalLinksModule)(); };
ExternalLinksModule.ɵmod = i0.ɵɵdefineNgModule({ type: ExternalLinksModule });
ExternalLinksModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[PrimengLibraryModule,
            ReactiveFormsModule,
            InputSwitchModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExternalLinksModule, { declarations: [ExternalLinksComponent], imports: [PrimengLibraryModule,
        ReactiveFormsModule,
        InputSwitchModule], exports: [ExternalLinksComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExternalLinksModule, [{
        type: NgModule,
        args: [{
                declarations: [ExternalLinksComponent],
                imports: [PrimengLibraryModule,
                    ReactiveFormsModule,
                    InputSwitchModule
                ],
                exports: [ExternalLinksComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of external-links
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ExternalLinksComponent, ExternalLinksModule, ExternalLinksService };
//# sourceMappingURL=external-links.js.map
